export default "__VITE_ASSET__PyrQVc8m__"